export default "__VITE_ASSET__11332ad0__"